import { render, staticRenderFns } from "./t-button.vue?vue&type=template&id=c05795c4"
import script from "./t-button.vue?vue&type=script&setup=true&lang=ts"
export * from "./t-button.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports